import * as _ from "lodash";

class PriorityLane {
	static Scheduled = {name: "Scheduled Program", priority: 3};
	static Lane2 = {name: "Priority Lane 2", priority: 2};
	static Lane1 = {name: "Priority Lane 1", priority: 1};
	static Split = {name: "Split", priority: 4};

	static get() {
		return _.keys(this).map(l => this[l]);
	}

	static getNameByPriority(priority) {
		return _.values(this).find(l => l.priority === priority)?.name;
	}
}
export default PriorityLane;
